import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import { BASE_URL } from "../../config/axios";



// import { formattedDateLong } from "../Date";
// import UpdateProjectDetails from "../Modals/UpdateProjectDetails"

import { AddDepartment } from "./AllLetterModal";
// import Department from "../AddDepartment/Department"

const AllLetterDetails = (projectID) => {


    // console.log("location.state")
    // console.log(location.state)
    // console.log("projectID")
    console.log(projectID, "allleter details >>>>>>>>")

    const [buffer, setBuffering] = useState(false);

    const [clientslist, setClientsList] = useState([]);
    const [clientExists, setClientExists] = useState(false);

    const [client, setClient] = useState(null);
    const [clientwiseID, setClientWise] = useState(null);

    const [toggleState, settoggleState] = useState(1);

    const [project, setProject] = useState([]);
    const [departmentlist, setDepartmentlist] = useState([]);
    const getProjectDetails = async () => {
        try {
            const ress = await axios.get(
                `${BASE_URL}detail-design/projectupdate/${projectID.projectID}/`
            );
            setProject(ress.data);
        } catch (err) { }
    };

    // const getDepartmentList = async () => {
    //     try {
    //         const ress = await axios.get(
    //             `${BASE_URL}/detail-design/highwaydepartment/`
    //         );
    //         setDepartmentlist(ress.data);
    //     } catch (err) { }
    // };

    const getProjectClientList = async () => {
        setBuffering(true);
        try {
            const clientdetails = await axios.get(
                `${BASE_URL}/detail-design/client/${projectID}/`
            );
            setClientsList(clientdetails.data);
            setClientExists(clientdetails.data?.normal_client.length > 0);
            settoggleState(
                clientdetails.data?.normal_client.length > 0 ? 1 : 5
            );

            console.log("clientdetails");
            console.log(clientdetails.data?.normal_client?.length > 0);

            setClient(clientdetails.data?.normal_client[0]?.client);
            setClientWise(clientdetails.data?.normal_client[0]?.id);
            if (clientdetails.data?.normal_client?.length > 0) {
            } else {
                setClient(undefined);
                setClientWise(undefined);
            }
        } catch (err) {
            // handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        if (projectID) {
            getProjectDetails();
        }

        // getProjectClientList();
        getDepartmentData();
    }, [projectID]);

    const [allEmployeeData, setAllEmployeeData] = useState([]);

    useEffect(() => {
        getEmployeeDetails();
        getDepartmentData();
    }, []);

    const getEmployeeDetails = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanysdep/${sessionStorage.getItem(
                    "departmentid"
                )}/`
            );
            setAllEmployeeData(res.data);
        } catch (err) {
            // alert(err.message);
        }
    };

    const getDepartmentData = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/detail-design/highwaydepartment/`
            );
            setDepartmentlist(res.data);
            console.log({ dept: res.data })
        } catch (err) {
            // alert(err.message);
        }
    };


    return (

        <>

            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />







            {
                <div className="filter-outer-box" style={{
                    padding: "0px 30px"
                }}>
                    <div
                        className="toggle-button-area"
                        style={{
                            padding: "0px 0px 0px 0px",
                            width: "100%",
                        }}
                    >
                        <div className="left-expense-bloc-tab wfm-margin">
                            <div>

                                {departmentlist.length > 0 && departmentlist.map((dept, index) => (
                                    <button
                                        key={dept.id}
                                        className={
                                            toggleState === index + 1
                                                ? "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponent-active-tabs"
                                                : "dashboardcomponent-tabs font-weight400 font-size-subheading dashboardcomponents-tabs-color"
                                        }
                                        onClick={() => settoggleState(index + 1)}
                                    >
                                        {dept?.division_name}
                                    </button>
                                ))}
                            </div>

                        </div>
                        <div className="right-expense-bloc-tab">
                            <div>
                                <AddDepartment
                                    projectID={projectID}
                                    getDepartmentList={getDepartmentData}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            }




        </>
    );
};

export default AllLetterDetails;